import { Alert, Card, CardContent, CardHeader, LinearProgress, Link, Stack } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
import { useInboxClient } from '../../hooks';
export const InboxCard = (props) => {
    const { t } = useAlertUiTranslation();
    const inboxClient = useInboxClient();
    const [countUnread, setCountUnread] = React.useState();
    const [countRequireResponse, setCountRequireResponse] = React.useState();
    const [error, setError] = React.useState();
    React.useEffect(() => {
        const requestUnread = { read: false, page: 1, size: 0 };
        const requestRequireResponse = { waitingForResponse: true, page: 1, size: 0 };
        Promise.all([inboxClient.getList(requestUnread), inboxClient.getList(requestRequireResponse)])
            .then(([unreadResponse, waitingResponse]) => {
            setCountUnread(unreadResponse.totalCount);
            setCountRequireResponse(waitingResponse.totalCount);
        })
            .catch(setError);
    }, [inboxClient]);
    const InboxCardContent = () => {
        if (error) {
            return React.createElement(Alert, { severity: 'error' }, t('errorMessage'));
        }
        if (countUnread === undefined || countRequireResponse === undefined) {
            return React.createElement(LinearProgress, null);
        }
        return (React.createElement(Stack, { spacing: 2, alignItems: 'flex-start' },
            React.createElement(Link, { style: { cursor: 'pointer' }, onClick: () => props.onUnreadClick(), tabIndex: 0, variant: 'body1', "data-test": 'unread-notifications-count-link' }, t('inboxCard.unreadNotifications', { count: countUnread })),
            React.createElement(Link, { style: { cursor: 'pointer' }, onClick: () => props.onRequireResponseClick(), tabIndex: 0, variant: 'body1', "data-test": 'require-response-count-link' }, t('inboxCard.requireResponse', { count: countRequireResponse }))));
    };
    return (React.createElement(Card, { "data-test": 'inbox-card', sx: { width: '100%', height: '100%' } },
        React.createElement(CardHeader, { sx: { display: 'inline-flex' }, title: t('inboxCard.titleNotifications'), "data-test": 'inbox-card-title', action: props.headerAction }),
        React.createElement(CardContent, { "data-test": 'inbox-card-content' },
            React.createElement(InboxCardContent, null))));
};
